import React from "react";
import { Card, CardTitle, Row, Button, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getCreditNoteStatus, getFormatedDate, getTimeFormat } from "../../../services/commonFunction";

const RemarkHistory = () => {
    const session = useSelector((state) => state.session);
    const navigate = useNavigate();

    const changesLogData = session.changesLogData?.data || [];
    const redirectUrl = session.changesLogData?.redirect;

    const hasData = Array.isArray(changesLogData) && changesLogData.length > 0;

    const normalizedData = hasData
        ? changesLogData.map((item, index) => {
              const dateObj = new Date(item.cnr_created_at);

              return {
                  srNo: index + 1,
                  date: dateObj,
                  time: dateObj,
                  createdBy: item.user_name,
                  cnr_status: item.cnr_status,
                  remark: item.cnr_remark_html?.replace(/<[^>]*>/g, ""),
              };
          })
        : [];

    return (
        <Row>
            <Col>
                <Card>
                    <CardTitle tag="h5" className="history_title">
                        <div>
                            Credit Note <i className="bi bi-chevron-right card-title-icon"></i>{" "} History
                        </div>
                    </CardTitle>

                    <div className="historyContainer">
                        {hasData ? (
                            <Row className="autoWidthImportant sampleverification-table module-log-history module-log-history-creditnote">
                                <>
                                    <div className="renderList_table_heading my-2">
                                        <h2>Remark History</h2>
                                    </div>

                                    <table className="table table-sm table-white borderless align-middle renderTable">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Sr. No</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                                <th>Created By</th>
                                                <th>Status</th>
                                                <th>Remark</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {normalizedData.map((row) => (
                                                <tr key={row.srNo}>
                                                    <td className="text-center">{row.srNo}</td>
                                                    <td>{getFormatedDate(row.date, 1)}</td>
                                                    <td>{getTimeFormat(row.time)}</td>
                                                    <td>{row.createdBy}</td>
                                                    <td>{getCreditNoteStatus(row.cnr_status)}</td>
                                                    <td title={row.remark}>{row.remark}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            </Row>
                        ) : (
                            <div className="historyContainerItemBox">
                                <p>No History Found</p>
                            </div>
                        )}
                    </div>
                </Card>

                <div className="submit_btns">
                    <Button
                        className="saveBtn"
                        id="submit_btn3"
                        onClick={() => navigate(redirectUrl || -1)}
                    >
                        Back To List
                    </Button>
                </div>
            </Col>
        </Row>
    );
};

export default RemarkHistory;